import { Injectable } from '@angular/core';

@Injectable()
export class AutoCompleteInsertService {

  createOptionOnSelect2(selectId: string, optionToSet: any) {
    var option: any = document.createElement("OPTION");
    option.setAttribute("value", optionToSet.id);
    var text = document.createTextNode(optionToSet.text);
    option.appendChild(text);
    var element: any = document.getElementById(selectId);
    if (element) {
      element.appendChild(option);
    }
    $("#" + selectId + " select").append(option);
  }

  setValueOnSelect2(value:any, selectedId: any) {
    var select: any = $("#" + selectedId + " select");
    select.val(value).trigger("change");
  }

  setNewTagInList(state: any) {
    var text: string;
    if(state.text === "") {
      text = "Digite o valor para adicionar à lista";
    } else {
      text = "Inserir <b>\""+state.text+"\"</b>";
    }
    return $('<span class="last_item_select2"> ' + text + '</span>');
  }

  getTextSelect2(obj: any, att: string) {
    var text: string = obj.text;
    if (obj[att]) {
      text = obj[att];
    }

    return text;
  }

  //storage
  setSessionStorage(item: any, module: string) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem('autocomplete-insert-' + module, object);
  }

  getSessionStorage(module: string) {
    var item: string = sessionStorage.getItem("autocomplete-insert-" + module);
    return JSON.parse(item);
  }

  clearSessionStorage(module: string) {
    sessionStorage.removeItem("autocomplete-insert-" + module);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/components/autocomplete-insert/autocomplete-insert.service.ts
 **/